export default {
  buttons: {
    send_code: 'Send Login Code',
  },
  placeholders: {
    mobile_number: 'Mobile Number',
  },
};
